const tooltipText = {
  preview: "Preview",
  salesPay: "Someone pay me",
  delete: "Delete",
  update: "Update",
  refund: "Refund this Transaction to Customer",
  invoicePaid: "Invoice Fully Paid",
  createInvoice: "Create New Invoice",
  createInvRecur: "Create New Invoice Recurring",
  saleRecurOver: "Recurring Overview",
  paidOver: "Paid Overview",
  draftOver: "Draft/Estimate Overview",
  dueOver: "Due Overview",
  overdueOver: "Overdue Overview",
  allOver: "All Overview contains all the sales transactions in the system",
  backSaleOver: "Go back to Sales Overview",
  addClient: "Add new client in this company",
  addItem: "Add new item in this company",
  addMulLineInv: "Add another detail",
  remMulLineInv: "Remove this line",
  deleteRefund: "Delete Refund",
  purCreditApply: "Apply Purchase Credit Note",
  purSupPay: "Pay Supplier Payment",
  supRefund: "Apply Supplier Refund",
  voidOrder: "Void This Line",
};
export default tooltipText;
